import { createFileRoute, Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { WBSButton } from '@/common/WBSButton';
import FollowUpNetworkMapView from '@/follow-up-network/FollowUpNetworkMapView';
import { PageContainer } from '~/styles/boardStyles';
import { GroupHeaderWrapper, Title } from '~/styles/layoutElements';

export const Route = createFileRoute('/_app/follow-up-network/map')({
  component: FollowUpNetworkMapScreen,
});

/**
 * `themes/wbs/buddypress/groups/single/follow-up-network-map.php` — the same
 * people, plotted.
 *
 * ITS HEADING IS ITS OWN: `_e('Follow-up Network Map')` (`:2`), against the
 * list template's `_e('Follow-up Network')`. The two views do not share a
 * title, which is why the header lives on each child route rather than on the
 * layout. Its one control is the `View List` anchor back (`:4`).
 */
function FollowUpNetworkMapScreen() {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <GroupHeaderWrapper>
        <Title>{t('wbs.follow-up-network-map')}</Title>
        <WBSButton as={Link} to="/follow-up-network" wide>
          {t('wbs.view-list')}
        </WBSButton>
      </GroupHeaderWrapper>
      <FollowUpNetworkMapView />
    </PageContainer>
  );
}
